export default {
  modalTitle: {
    id: 'shopping_assistant_modal_title',
    defaultMessage: 'Back Market AI',
  },
  newChat: {
    id: 'shopping_assistant_new_chat_button',
    defaultMessage: 'New conversation',
  },
  closeChat: {
    id: 'shopping_assistant_close_chat_button',
    defaultMessage: 'Close conversation',
  },
  inputPlaceholder: {
    id: 'shopping_assistant_input_placeholder',
    defaultMessage: 'Ask Back Market AI…',
  },
  sendMessage: {
    id: 'shopping_assistant_send_message_button',
    defaultMessage: 'Send message',
  },
  emittedFromMe: {
    id: 'shopping_assistant_emitted_from_me_alternative_text',
    defaultMessage: 'I say:',
  },
  emittedFromAssistant: {
    id: 'shopping_assistant_emitted_from_assistant_alternative_text',
    defaultMessage: 'Assistant says:',
  },
  promptSuggestionsTitle: {
    id: 'shopping_assistant_prompt_suggestions_title',
    defaultMessage: 'Suggested prompts',
  },
} as const
